module.exports = __webpack_public_path__ + "img/14.1.850df4c1.png";